'use strict';

angular.module('app').directive('tabs', function ($window) {
  return {
    restrict: 'E',
    scope: {
      titles: '=',
      templates: '='
    },
    replace: true,
    template: '<div class="tabs-wrap">' +
        '<ul class="tabs-menu" ng-init="isActiveTab = titles[0]">' + 
          '<li ng-repeat="title in titles"' +
          'ng-class="{ active: $parent.isActiveTab == title }"' +
          'ng-click="$parent.isActiveTab = title; showContainer($index)">{{ title }}</li>' +
        '</ul>' +
        '<div class="tabs-container-wrap" ng-init="isActiveContent = templates[0]">' +
          '<div class="tabs-container fade-onload"' +
                'ng-repeat="template in templates"' +
                'ng-class="{ hidden: $parent.isActiveContent !== template }">' +
            '<ng-include src="template">{{template}}</ng-include>' +
          '</div>' +
        '</div>'+
      '</div>',
    link: function(scope, elem, attr) {
      scope.$watch('isActiveTab', function(newVal) {
        if(newVal) {
          scope.showContainer = function(index) {
            scope.isActiveContent = scope.templates[index];
          };
        }
      });
    }
  }
})
